import type { ReactElement } from "react";
import { CmtsPermissionsPage } from "../../pages/cmtsPermissionsPage.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(_props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsPermissionsPage />;
}

export default Component;
